import type { History, Tone } from './types';
import { historyStat, toneClass, wavePaths } from './quality';

/**
 * "Bandwidth · quality" oscilloscope, last 5 minutes (60 windows of 5 s).
 * Height = bandwidth, colour = quality of the window, dashed = what the source
 * sends (the target for a destination), dotted grey = no data.
 */
export function QualityWave({ history, summary, title = 'Bandwidth · quality', height = 48, targetMbps }: {
  history: History; summary?: { text: string; tone: Tone }; title?: string; height?: number; targetMbps?: number;
}) {
  const W = 240;
  const p = wavePaths(history, W, height, targetMbps);
  return (
    <div className="flex flex-col gap-1">
      <div className="flex justify-between gap-2 text-[11px] text-muted">
        <span>{title}</span>
        <span className="font-mono">{historyStat(history)}</span>
      </div>
      <svg viewBox={`0 0 ${W} ${height}`} preserveAspectRatio="none" width="100%" height={height} aria-hidden="true" className="block rounded-md bg-bg">
        {p.target && <path d={p.target} className="stroke-line-2" strokeDasharray="2 4" fill="none" vectorEffect="non-scaling-stroke" />}
        <path d={p.idle} className="stroke-slot" strokeDasharray="2 3" strokeWidth="1.4" fill="none" vectorEffect="non-scaling-stroke" />
        <path d={p.good} className="stroke-live" strokeWidth="1.6" strokeLinejoin="round" fill="none" vectorEffect="non-scaling-stroke" />
        <path d={p.warn} className="stroke-warn" strokeWidth="2" fill="none" vectorEffect="non-scaling-stroke" />
        <path d={p.bad} className="stroke-fail" strokeWidth="2" fill="none" vectorEffect="non-scaling-stroke" />
      </svg>
      <div className="flex justify-between font-mono text-[10px] text-muted"><span>5 min ago</span><span>now</span></div>
      {summary && (
        <div title={summary.text} className={`truncate text-xs ${toneClass[summary.tone]}`}>{summary.text}</div>
      )}
    </div>
  );
}
